import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { isDevMode } from '@angular/core';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import { AuthState } from './auth/auth.state';
import { authReducer } from './auth/auth.reducer';
import { UiState } from './ui/ui.state';
import { uiReducer } from './ui/ui.reducer';
import { CommonState } from './common/common.state';
import { commonReducer } from './common/common.reducer';

export interface AppState {
    router: RouterReducerState;
    auth: AuthState;
    ui: UiState;
    common: CommonState;
}

export const reducers: ActionReducerMap<AppState> = {
    router: routerReducer,
    auth: authReducer,
    ui: uiReducer,
    common: commonReducer,
};

export const metaReducers: MetaReducer<AppState>[] = isDevMode() ? [] : [];
